module.exports = __webpack_public_path__ + "img/pr-7.e71ab68b.png";